import { FormInstanceElement } from '../form-instance-element.model';
import { IGridRow, IValuesByFieldName } from '../../../interfaces/grid-row.interface';
import { FormField } from '../form-field.model';
import { FieldDefinitionService } from '../../../services/field-definition.service';
import { FormulaEvaluationHelper } from '../../../components/form-fields/formula-form-field/formula-evaluation-helper';
import { FormulaEvaluator } from '../../../components/form-fields/formula-form-field/formula-evaluator';
import { FormFieldProcessingPhaseEnum } from '../../../enums/form-field-processing-phase.enum';
import { TextFieldDefinitionLogicBase } from './text-logic-base';

// See https://community-dc.max.gov/x/h4Gzmw for overview of how the Concatenator Field is implemented
export class ValueConcatenatorFieldDefLogic extends TextFieldDefinitionLogicBase {
    // Constructor.
    public constructor(private fieldDefinitionServce: FieldDefinitionService) {
        super();
    }

    public whenInGridShowAs(): string {
        return 'BUTTON';
    }

    public getDisplayValue(formFieldParam: FormField, formInstanceElementParam: FormInstanceElement, gridRow: IGridRow, processingPhase: FormFieldProcessingPhaseEnum, gridRowColumnDefs: FormField[], setDefault: boolean = true): string {
        let displayValue: string = '';
        if (gridRowColumnDefs != null) {
            // If the field is used in a Grid, assume it's being used for a url and needs to be calculated based on the current values in the grid row (this may need to be revisited)
            let hshFieldValues: IValuesByFieldName = gridRow.getValuesByFieldName(this.fieldDefinitionServce);
            let formulaEvaluationHelper = new FormulaEvaluationHelper().init(formFieldParam, gridRow, gridRowColumnDefs);
            let url = FormulaEvaluator.concatenateValues(formulaEvaluationHelper, formFieldParam.formula, hshFieldValues);
            displayValue = url;
        } else {
            displayValue = formInstanceElementParam.textValue;
        }

        return displayValue;
    }

    public requiresFieldValueUpdate(): boolean {
        return true;
    }

    private static displayNameToVariableName(formFieldParam: FormField): string {
        let variableName: string = formFieldParam.displayName.toLowerCase().replace(/ /g, '_');

        return (variableName);
    }

    public filterType(): string {
        return 'text';
    }

    public isFilterable(): boolean {
        return false;
    }

    // this field displays as a button in a grid cell, and we don't want clicking the button to place the grid row into edit mode
    public doNotTriggerGridRowEditFor(): boolean {
        return true;
    }
}
